document.addEventListener('DOMContentLoaded', function() {
    const lightbox = GLightbox();

    document.querySelectorAll('[data-video-trigger]').forEach((trigger) => {
        const playVideo = () => {
            const mediaWrapper = trigger.closest('.about--img, .award--img');
            const embed = mediaWrapper?.querySelector('[data-video-embed]');
            const iframe = embed?.querySelector('iframe');

            if (!embed || !iframe) {
                return;
            }

            const videoUrl = trigger.dataset.videoEmbedUrl;

            if (videoUrl) {
                iframe.setAttribute('src', videoUrl);
            }

            embed.hidden = false;
            mediaWrapper?.classList.add('is-playing');
        };

        trigger.addEventListener('click', playVideo);
        trigger.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                playVideo();
            }
        });
    });

    setTimelineYearLabels();

    function setTimelineYearLabels() {
        const timelineSlides = document.querySelectorAll('.swiper-timeline .swiper-slide');
        const controllerSlides = document.querySelectorAll('.swiper-timeline-controller .swiper-slide');

        timelineSlides.forEach((slide, i) => {
            const label = slide.getAttribute('data-title');
            const yearElement = controllerSlides[i]?.querySelector('.year');

            if (label && yearElement) {
                yearElement.textContent = label;
            }
        });

    }

    const animateDivider = () => {
        const activeDivider = document.querySelector('.swiper-timeline .swiper-slide-active .divider');

        document.querySelectorAll('.swiper-timeline .divider').forEach((divider) => {
            divider.classList.remove('is-animating');
        });

        requestAnimationFrame(() => {
            activeDivider?.classList.add('is-animating');
        });
    };

    // swipers 
    const swiperTimeline = new Swiper('.swiper-timeline', {
        slidesPerView: 1,
        speed: 1000,
        direction: 'vertical',
        allowTouchMove: false,
        // fade: true,
    })

    const swiperTimelineController = new Swiper('.swiper-timeline-controller', {
        slidesPerView: 5,
        centeredSlides: true,
        speed: 1000,
        direction: 'vertical',
        // fade: true,
        
        navigation: {
            prevEl: '.swiper-timeline-controller .swiper-button-prev',
            nextEl: '.swiper-timeline-controller .swiper-button-next'
        },
        thumbs: {
            swiper: swiperTimeline
        },
        breakpoints: {
            992: {
                // slidesPerView: 6,
                centerInsufficientSlides: false,
                autoHeight: false,
            }
        }
    })

    swiperTimeline.on('slideChangeTransitionEnd', animateDivider);
    swiperTimelineController.on('slideChangeTransitionEnd', animateDivider);
    animateDivider();

    // No mobile o conteúdo do slide (título de duas linhas + texto) passa da
    // altura fixa do CSS e é cortado. Como o swiper é vertical, ele precisa de
    // altura definida: mede o slide mais alto e aplica essa altura.
    const timelineEl = document.querySelector('.swiper-timeline');

    function fitTimelineHeight() {
        if (!timelineEl) {
            return;
        }

        // desktop mantém a altura fixa do CSS
        if (window.innerWidth >= 992) {
            timelineEl.style.height = '';
            swiperTimeline.update();
            return;
        }

        let tallest = 0;

        timelineEl.querySelectorAll('.swiper-slide').forEach((slide) => {
            const wrapper = slide.querySelector('.wrapper');

            if (!wrapper) {
                return;
            }

            const slideTop = slide.getBoundingClientRect().top;
            const wrapperBottom = wrapper.getBoundingClientRect().bottom;

            tallest = Math.max(tallest, wrapperBottom - slideTop);
        });

        if (tallest) {
            timelineEl.style.height = `${Math.ceil(tallest)}px`;
            swiperTimeline.update();
        }
    }

    fitTimelineHeight();

    // as fontes mudam a quebra de linha dos títulos
    if (document.fonts) {
        document.fonts.ready.then(fitTimelineHeight);
    }

    let timelineResizeTimeout;

    window.addEventListener('resize', () => {
        window.clearTimeout(timelineResizeTimeout);
        timelineResizeTimeout = window.setTimeout(fitTimelineHeight, 200);
    });

    const galleryAccordion = document.querySelector('[data-gallery-accordion]');

    const isMobile = () => {
        window.innerWidth > 992;
    }

    if (!isMobile()) {
        if (galleryAccordion) {
            const gallerySlides = Array.from(galleryAccordion.querySelectorAll('.gallery-accordion__slide')).slice(0, 5);
            const prevButton = document.querySelector('.gallery .arrow-left');
            const nextButton = document.querySelector('.gallery .arrow-right');
            let activeIndex = gallerySlides.findIndex(slide => slide.classList.contains('is-active'));
            let isGalleryAnimating = false;
    
            if (activeIndex < 0) {
                activeIndex = 0;
            }
    
            function getSlideCenter(slide) {
                const slideRect = slide.getBoundingClientRect();
    
                return slideRect.left + (slideRect.width / 2);
            }
    
            function setActiveGallerySlide(index, animate = true) {
                if (!gallerySlides.length) {
                    return;
                }
    
                if (isGalleryAnimating) {
                    return;
                }
    
                const nextIndex = (index + gallerySlides.length) % gallerySlides.length;
    
                if (nextIndex === activeIndex && animate) {
                    return;
                }
    
                const activeCenter = getSlideCenter(gallerySlides[activeIndex]);
                const nextCenter = getSlideCenter(gallerySlides[nextIndex]);
                const swipeDistance = Math.abs(nextCenter - activeCenter);
                const swipeDirection = nextCenter >= activeCenter ? 1 : -1;
    
                activeIndex = nextIndex;
    
                const updateSlides = () => gallerySlides.forEach((slide, i) => {
                    const relativePosition = (i - activeIndex + gallerySlides.length) % gallerySlides.length;
    
                    slide.style.order = (relativePosition + 2) % gallerySlides.length;
                    slide.classList.toggle('is-active', relativePosition === 0);
                    slide.classList.toggle('is-adjacent', relativePosition === 1 || relativePosition === gallerySlides.length - 1);
                });
    
                if (animate) {
                    isGalleryAnimating = true;
                    updateSlides();
    
                    galleryAccordion.style.transition = 'none';
                    galleryAccordion.style.transform = `translateX(${swipeDirection * swipeDistance}px)`;
    
                    galleryAccordion.offsetHeight;
    
                    galleryAccordion.style.transition = '';
                    galleryAccordion.style.transform = '';
                    window.setTimeout(() => {
                        isGalleryAnimating = false;
                    }, 800);
                    return;
                }
    
                updateSlides();
            }
    
            gallerySlides.forEach((slide, i) => {
                slide.addEventListener('click', () => setActiveGallerySlide(i));
            });
    
            prevButton?.addEventListener('click', () => setActiveGallerySlide(activeIndex - 1));
            nextButton?.addEventListener('click', () => setActiveGallerySlide(activeIndex + 1));
            setActiveGallerySlide(activeIndex, false);
        }
    }

    // com poucas fotos o loop repete a mesma imagem nas laterais
    const gallerySlidesCount = document.querySelectorAll('.swiper-gallery .swiper-slide').length;

    const swiperGallery = new Swiper('.swiper-gallery', {
        slidesPerView: 1.2,
        centeredSlides: true,
        spaceBetween: 16,
        speed: 1000,
        loop: gallerySlidesCount >= 4,
        effect: 'coverflow',
        
        coverflowEffect: {
            rotate: 0,
            stretch: 0,
            depth: 200,
            modifier: 1,
            slideShadows: false
        },
        navigation: {
            prevEl: '.gallery .arrow-left',
            nextEl: '.gallery .arrow-right'
        },
        on: {
            init() {
                destroySwiperOnMobile(this);
            },
            resize() {
                destroySwiperOnMobile(this);
            }
        }
    });

    function destroySwiperOnMobile(swiper) {
        if (isMobile) {
            swiper.init();
        } else {
            swiper.destroy(true, true)
        }
    }

    const swiperTech = new Swiper('.swiper-tech', {
        slidesPerView: 1,
        loop: true,
        speed: 1000,
        spaceBetween: 12,

        pagination: {
            el: '.swiper-tech .swiper-pagination',
            clickable: true
        },
    })
})
